module.exports = __webpack_public_path__ + "static/media/1830.8327cfec.jpg";